<script lang="ts" setup>

  type Props = {
    fullscreen?: boolean
    mode?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    fullscreen: true,
    mode: 'modal',
  })

  const emit = defineEmits<{
    (e: 'close'): void
  }>()

  const isFadingOut = ref(false)

  function close() {
    isFadingOut.value = true
    emit('close')
  }

</script>
<template>
  <div
    class="lc-backdrop"
    :class="[{
      fullscreen: props.fullscreen,
      hidden: isFadingOut
    }, mode]"
    @click="close"
  >
    <slot />
  </div>
</template>
<style scoped>

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.lc-backdrop {
  position: fixed;
  z-index: 10;
  top: 3.875em;
  left: 0;
  width: 100%;
  height: 100%;
  animation: fade-in 0.5s ease;
  background-color: rgb(26 44 54 / 40%);
  cursor: pointer;
  opacity: 1;
  transition: opacity ease-in-out 0.15s, visibility ease-in-out 0.15s, top ease-in-out 0.15s;
  visibility: visible;

  &.hidden {
    animation: fade-out 0.5s ease;
    opacity: 0;
    visibility: hidden;
  }

  &.drawer {
    top: 3.875em;

    @media screen and (width >= 1024px) {
      top: 5.25em;
    }
  }

  &.fullscreen {
    top: env(safe-area-inset-top);
    bottom: env(safe-area-inset-top);
    height: auto;
  }

  @media screen and (width >= 1024px) {
    top: 5.5em;
  }
}
</style>
